<div class="confirm-dialog-container">
  <p class="title">{{data.title}}</p>
  <p class="message">{{data.message}}</p>
  <div class="actions">
    <button (click)="closeAction(true)" mat-raised-button class="accept"><span>Aceptar</span></button>
    <div class="divisor"></div>
    <button (click)="closeAction(false)" mat-raised-button><span>Cancelar</span></button>
  </div>
</div>
